// src/components/ColorGuideModal.jsx
import React from 'react';

const ColorGuideModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    const hairColors = [
        { code: "1", name: "Jet Black", hex: "#0a0a0a", desc: "The darkest, coolest black." },
        { code: "1B", name: "Off Black / Natural", hex: "#1c1918", desc: "Natural undyed black with warm undertones. Most common." },
        { code: "2", name: "Darkest Brown", hex: "#2a221f", desc: "A very dark brown that can look black in low light." },
        { code: "4", name: "Medium Brown", hex: "#4b3629", desc: "A rich, chocolatey brown." },
        { code: "27", name: "Honey Blonde", hex: "#d8a664", desc: "A warm, golden strawberry blonde." },
        { code: "30", name: "Light Auburn", hex: "#8b4513", desc: "A medium, warm copper/auburn shade." },
        { code: "33", name: "Dark Auburn", hex: "#5c2a16", desc: "A deep, rich mahogany red." },
        { code: "99J", name: "Burgundy", hex: "#4a0404", desc: "A deep, vibrant wine/plum red." },
        { code: "613", name: "Platinum Blonde", hex: "#f0e2b6", desc: "A very light, bleached platinum blonde." },
    ];

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.85)', zIndex: 9999,
            display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px'
        }}>
            <div style={{
                background: '#111', border: '1px solid #d4af37', borderRadius: '4px',
                width: '100%', maxWidth: '600px', maxHeight: '80vh', overflowY: 'auto',
                position: 'relative'
            }}>
                <div style={{
                    position: 'sticky', top: 0, background: '#111', padding: '20px',
                    borderBottom: '1px solid #333', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 2
                }}>
                    <h3 style={{ color: '#d4af37', margin: 0, fontFamily: "'Cinzel', serif", textTransform: 'uppercase', letterSpacing: '2px' }}>
                        Color Guide
                    </h3>
                    <button
                        onClick={onClose}
                        style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '1.5rem', cursor: 'pointer' }}
                    >
                        &times;
                    </button>
                </div>

                <div style={{ padding: '20px' }}>
                    <p style={{ color: '#a0aec0', fontSize: '0.9rem', marginBottom: '20px' }}>
                        Use this standard industry guide to help select your perfect shade. Please note that exact tones may vary slightly depending on your screen settings.
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {hairColors.map((color) => (
                            <div key={color.code} style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '10px', background: 'rgba(255,255,255,0.02)', borderRadius: '4px', border: '1px solid #222' }}>
                                <div style={{
                                    width: '50px', height: '50px', borderRadius: '50%', backgroundColor: color.hex,
                                    border: '2px solid #333', flexShrink: 0,
                                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.5)'
                                }} />
                                <div>
                                    <h4 style={{ color: '#fff', margin: '0 0 5px 0', fontSize: '1rem' }}>
                                        <span style={{ color: '#d4af37', marginRight: '8px' }}>#{color.code}</span>
                                        {color.name}
                                    </h4>
                                    <p style={{ color: '#888', margin: 0, fontSize: '0.85rem' }}>{color.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ColorGuideModal;